import React, { useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import _ from "lodash";
import {
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { useFormikContext } from "formik";
import { DialogActions, TextField } from "@material-ui/core";
import {
  getOutletSellItems,
  getOutletStocks,
} from "../../../../../services/sales/outletService";
import { Card } from "react-bootstrap";
import { Paginator } from "primereact/paginator";
import PosItem from "./posItem";
import { useEffect } from "react";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchCustomer from "../../customers/searchCustomer";
import { amountByPercent, percentByAmount } from "../../../../../utils/utils";
import SearchUser from "../../../users/users/searchUser";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import Swal from "sweetalert2";
import SearchVariant from "../../../inventory/items/searchVariant";
function PosHeader({
  outletID = 0,
  setOpenPaymentForm,
  setOpenAddress,
  setOpenSalesNote,
}) {
  const { values, resetForm, setFieldValue } = useFormikContext();
  const [sellItemList, setSellItemList] = useState([]);
  const [outletStocks, setOutletStocks] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemName, setSelectedItemName] = useState("");
  const [openSearchCustomer, setOpenSearchCustomer] = useState(false);
  const [openSearchSales, setOpenSearchSales] = useState(false);
  const [openSearchVariant, setOpenSearchVariant] = useState(false);
  const [firstRecord, setFirstRecord] = useState(0);
  const [rowsRecord, setRowsRecord] = useState(12);
  const [lastRecord, setLastRecord] = useState(12);
  const onBasicPageChange = (event) => {
    setFirstRecord(event.first);
    setRowsRecord(event.rows);
    setLastRecord(event.first + event.rows);
  };

  useEffect(() => {
    getOutletStocksData(outletID);
    getOutletItemSellList(outletID);
  }, [outletID]);

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6">
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-4">
              <FormSelectField
                label="Scan By"
                name="scanBy"
                options={[
                  { label: "UPC", value: 1 },
                  { label: "Batch ID", value: 2 },
                ]}
              />
            </div>
            <div className="col-sm-8 col-md-8 col-lg-8">
              <TextField
                type="text"
                label={`Scan ${values.scanBy === 1 ? "UPC" : "Batch ID"}`}
                margin="normal"
                variant="outlined"
                size="small"
                fullWidth
                onKeyDown={(e) => {
                  handleScan(e);
                }}
              />
            </div>
          </div>

          {sellItemList && sellItemList.length > 0 ? (
            <Autocomplete
              freeSolo
              id="itemName"
              disableClearable
              options={sellItemList}
              value={selectedItem}
              inputValue={selectedItemName}
              size="small"
              getOptionLabel={(option) => {
                if (option && option.itemName) {
                  return option.item.itemCode + " " + option.itemName;
                } else {
                  return "";
                }
              }}
              onChange={(event, value) => {
                setSelectedItem(value);
                if (value.itemsVariant.length > 0) {
                  setSelectedItem(value);
                  setOpenSearchVariant(true);
                } else {
                  handleSelectItem(value, 0);
                }
              }}
              onInputChange={(event, inputValue) => {
                setSelectedItemName(inputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search By Item Name"
                  margin="normal"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
            />
          ) : null}
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              {sellItemList && sellItemList.length > 0 ? (
                <Paginator
                  first={firstRecord}
                  rows={rowsRecord}
                  totalRecords={sellItemList.length}
                  rowsPerPageOptions={[12, 24, 36, 48]}
                  onPageChange={onBasicPageChange}
                ></Paginator>
              ) : null}
              <div className="row">
                {sellItemList && sellItemList.length > 0
                  ? sellItemList.map((item, index) => (
                      <React.Fragment key={index}>
                        {index >= firstRecord && index < lastRecord ? (
                          <div className="col-sm-3 col-md-3 col-lg-3">
                            <Card
                              className="text-center my-2"
                              role="button"
                              onClick={() => {
                                if (item && item.itemID > 0) {
                                  if (item.itemsVariant.length > 0) {
                                    setSelectedItem(item);
                                    setOpenSearchVariant(true);
                                  } else {
                                    handleSelectItem(item, 0);
                                  }
                                }
                              }}
                              style={{
                                borderRadius: "6px",
                              }}
                            >
                              <Card.Img
                                variant="top"
                                src={
                                  item.item.itemImage &&
                                  item.item.itemImage.length > 0
                                    ? item.item.itemImage[0].imagePath
                                    : "../../../invifo/illustrations/blank_image.png"
                                }
                                style={{
                                  borderTopRightRadius: "6px",
                                  borderTopLeftRadius: "6px",
                                }}
                              />
                              <Card.Body className="p-1">
                                <ResponsiveEllipsis
                                  text={item.itemName}
                                  maxLine="1"
                                />
                              </Card.Body>
                            </Card>
                          </div>
                        ) : null}
                      </React.Fragment>
                    ))
                  : null}
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <FormTextField
            label="Customer Name"
            name="customerName"
            searchButton
            clearButton
            readonly
            clearFields={[
              { field: "customerID", clearValue: 0 },
              { field: "customerName", clearValue: "" },
            ]}
            onSearchClick={() => {
              setOpenSearchCustomer(true);
            }}
          />
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField
                label="Person Responsible"
                name="userName"
                readonly
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField
                label="Sales Agent"
                name="salesName"
                searchButton
                clearButton
                readonly
                clearFields={[
                  { field: "salesID", clearValue: 0 },
                  { field: "salesName", clearValue: "" },
                ]}
                onSearchClick={() => {
                  setOpenSearchSales(true);
                }}
              />
            </div>
          </div>
          <PosItem />
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <button
                    type="button"
                    className="btn btn-label-danger btn-md btn-pill btn-bold mt-3 w-100"
                    onClick={() => {
                      resetForm();
                    }}
                  >
                    <i className="fas fa-broom"></i>
                    Clear
                  </button>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <button
                    type="button"
                    className="btn btn-success btn-md btn-pill btn-bold mt-3 w-100"
                    onClick={() => {
                      if (values.total > 0 && values.salesPosItem.length > 0) {
                        setOpenPaymentForm(true);
                      } else {
                        Swal.mixin({
                          customClass: {
                            confirmButton:
                              "btn btn-success btn-md btn-pill btn-bold",
                          },
                          buttonsStyling: false,
                        }).fire({
                          title: "Failed",
                          text: "Grand Total cannot be zero or empty",
                          icon: "error",
                          showCloseButton: true,
                          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                        });
                      }
                    }}
                  >
                    <i className="fas fa-credit-card"></i>
                    Payment
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <button
                    type="button"
                    className="btn btn-label-primary btn-md btn-pill btn-bold mt-3 w-100"
                    onClick={() => {
                      setOpenAddress(true);
                    }}
                  >
                    <i className="fas fa-map-marked-alt"></i>
                    Delivery Address
                  </button>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <button
                    type="button"
                    className="btn btn-label-warning btn-md btn-pill btn-bold mt-3 w-100"
                    onClick={() => {
                      setOpenSalesNote(true);
                    }}
                  >
                    <i className="fas fa-sticky-note"></i>
                    Note
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchVariant}
        title={`Search Variant`}
        onCloseDialog={() => {
          setOpenSearchVariant(false);
        }}
        maxWIdth="sm"
      >
        {selectedItem !== null ? (
          <SearchVariant
            itemID={selectedItem.itemID}
            onSelectVariant={(varCode, valueName) => {
              for (const variant of selectedItem.itemsVariant) {
                if (variant.varCode === varCode) {
                  handleSelectItem(variant, 0);
                  break;
                }
              }
              setOpenSearchVariant(false);
            }}
            onCloseDialog={() => {
              setOpenSearchVariant(false);
            }}
          />
        ) : null}
      </DialogLayout>
      <DialogLayout
        open={openSearchSales}
        title="Search Sales Agent"
        onCloseDialog={() => {
          setOpenSearchSales(false);
        }}
        maxWIdth="md"
      >
        <SearchUser
          salesUser="true"
          onSelectUser={(user) => {
            setFieldValue("salesID", user.ID);
            setFieldValue("salesName", user.firstName + " " + user.lastName);
            setOpenSearchSales(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchSales(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchCustomer}
        title="Search Customer"
        onCloseDialog={() => {
          setOpenSearchCustomer(false);
        }}
        maxWIdth="lg"
      >
        <SearchCustomer
          onSelectCustomer={(customer) => {
            setFieldValue("customerID", customer.ID);
            setFieldValue("customerName", customer.customerName);
            setFieldValue("recipient", customer.customerName);
            setOpenSearchCustomer(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCustomer(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
  function handleScan(e) {
    let value = "";
    let item = {};
    if (e.key === "Enter") {
      const { scanBy } = values;
      switch (scanBy) {
        case 1:
          value = e.target.value;
          item = _.find(sellItemList, ["upc", value]);
          if (item && item.itemID > 0) {
            handleSelectItem(item, 0);
          }
          break;
        case 2:
          value = parseInt(e.target.value);
          const stock = _.find(outletStocks, ["batchID", value]);
          if (stock && stock.itemID > 0) {
            const item = _.find(sellItemList, {
              itemID: stock.itemID,
              varCode: stock.varCode,
            });
            if (item && item.itemID > 0) {
              handleSelectItem(item, value);
            }
          }
          break;
        default:
          break;
      }
    }
  }

  function handleSelectItem(
    item = { itemID: 0, varCode: "", publishPrice: 0 },
    batchID = 0
  ) {
    if (typeof item.uomName === "undefined") {
      return;
    }
    const salesPosItem = [...values.salesPosItem];
    let index = 0;
    if (batchID > 0) {
      index = _.findIndex(salesPosItem, {
        batchID: batchID,
      });
    } else {
      index = _.findIndex(salesPosItem, {
        itemID: item.itemID,
        varCode: item.varCode,
      });
    }
    let publishPrice = item.publishPrice;
    if (index < 0) {
      salesPosItem.push({
        discountFreeItemID: 0,
        discountAmountOffItemID: 0,
        outletID: outletID,
        itemID: item.itemID,
        varCode: item.varCode,
        qty: 1,
        batchID,
        uomID: item.uomID,
        uomName: item.uomName,
        subTotal: publishPrice,
        discountAmount: 0,
        discountPercent: 0,
        taxAmount: 0,
        taxPercent: 0,
        itemName: item.itemName,
        unitPrice: publishPrice,
        totalPrice: publishPrice,
        receiveType: 1,
        warehouseID: 0,
        warehouseName: "",
      });
    } else {
      salesPosItem[index].qty = parseFloat(salesPosItem[index].qty) + 1;

      const totalPrice =
        parseFloat(salesPosItem[index].qty) *
        parseFloat(salesPosItem[index].unitPrice);
      salesPosItem[index].subTotal = totalPrice;
      salesPosItem[index].discountAmount = amountByPercent(
        salesPosItem[index].discountPercent,
        totalPrice
      );
      salesPosItem[index].taxAmount = amountByPercent(
        salesPosItem[index].taxPercent,
        totalPrice
      );
      salesPosItem[index].totalPrice =
        publishPrice * parseFloat(salesPosItem[index].qty) -
        salesPosItem[index].discountAmount +
        salesPosItem[index].taxAmount;
    }
    setFieldValue("salesPosItem", salesPosItem);
    setFieldValue("subTotal", _.sumBy(salesPosItem, "totalPrice"));
    let total = _.sumBy(salesPosItem, "totalPrice");
    let discountAmount = 0;
    let discountPercent = 0;
    let taxAmount = 0;

    if (values.discountID > 0 && values.discount.discountType === 1) {
      if (values.discount.discountAmountType === 2) {
        discountAmount = values.discount.discountValue;
        discountPercent = percentByAmount(discountAmount, total);
      } else {
        discountPercent = values.discount.discountPercent;
        discountAmount = amountByPercent(discountPercent, total);
      }
      setFieldValue("discountPercent", discountPercent);
      setFieldValue("discountAmount", discountAmount);
    } else {
      discountPercent = values.discountPercent;
      discountAmount = values.discountAmount;
      if (discountPercent > 0) {
        discountAmount = amountByPercent(discountPercent, values.subTotal);
        setFieldValue("discountAmount", discountAmount);
      } else if (discountAmount > 0) {
        discountPercent = percentByAmount(discountAmount, values.subTotal);
        setFieldValue("discountPercent", discountPercent);
      }
    }

    total -= discountAmount;

    if (values.taxPercent > 0) {
      taxAmount = amountByPercent(values.taxPercent, values.total);
      setFieldValue("taxAmount", taxAmount);
    } else if (values.taxAmount > 0) {
      taxAmount = values.taxAmount;
      setFieldValue("taxPercent", percentByAmount(values.taxAmount, total));
    }
    total += taxAmount;

    setFieldValue("total", total);
    setFieldValue("selectedItem", { itemID: 0, varCode: "" });
    setFieldValue("selectedItemName", "");
  }

  async function getOutletStocksData(outletID = 0) {
    if (outletID > 0) {
      const response = await getOutletStocks(outletID);
      const { data } = response.data;
      const { outletStocks } = data;
      setOutletStocks(outletStocks);
    }
  }

  async function getOutletItemSellList(outletID = 0) {
    if (outletID > 0) {
      const response = await getOutletSellItems(outletID);
      const { data } = response.data;
      setSellItemList(data.itemList);
    }
  }
}

export default PosHeader;
